/**
 * 运维保障
 */
// import kcrawler from '@souche-f2e/kcrawler';

// import Vue from 'vue';
// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';

window.NODE_ENV = process.env.NODE_ENV;
window.BUILD_ENV = process.env.BUILD_ENV;
window.npm_package_version = process.env.npm_package_version;

// kcrawler();

// Raven
//     .config('https://3cc690b6338842bc9cb835e4e737bba0@sentry.souche-inc.com/108')
//     .addPlugin(RavenVue, Vue)
//     .install();



// WEBPACK FOOTER //
// ./src/plugins/sre.js